import React from "react";
import { useInView } from "react-intersection-observer";

function Trailer({trailer}) {

  const {inView , ref} = useInView()

  return (
    <section ref={ref} id={`${trailer ? 'trailer' : 'join'}`} >
      <div className="container section-container">
        <div className="trailer-main">
          <h3 className="section-title">{trailer? 'trailer' : 'Join Us'}</h3>
          <div className={` ${inView && "trailer--content"}`}>
            <iframe
              className="iframe"
              src={trailer? "https://youtube.com/embed/JP9n5wHyemU" :'https://youtube.com/embed/JP9n5wHyemU'}
            />
            <a href={`${trailer? '/staff' : 'https://minecraftpocket-servers.com/server/122269/vote/'}`} target={!trailer&& '_blank'}>
              <button className="trailer--btn"><span className='yellow'>{">"}</span> {trailer? "Learn more" : 'also'} <span className='yellow'>{trailer? "about founders" : "vote us"}</span></button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trailer;
